import React from "react";
import { Heading } from "../shared/Heading";
import { useContext } from "../../../../../context";
import { Input } from "../shared/Input";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { QuestionBox } from "../shared/QuestionBox";
import { BLOCK_FIELDS } from "../../../../../config";

export const Textbox = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey.preview",
  });

  const { blocks, previewAnswers } = useContext();
  const block = blocks.getCurrent();

  return (
    <QuestionBox>
      <Heading
        title={block[BLOCK_FIELDS.question]}
        description={block[BLOCK_FIELDS.description]}
        index={blocks.getCurrentIndex() + 1}
      />
      <Input
        value={previewAnswers.get(block.id)}
        onChange={(value) => previewAnswers.set(block.id, value)}
        placeholder={t("answerPlaceholder")}
      />
    </QuestionBox>
  );
};
